import { lazy } from 'react';

// project imports
import AuthGuard from 'utils/route-guard/AuthGuard';
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import SimulationPanel from 'ui-component/simulation';

// Page routings
const Dashboard = Loadable(lazy(() => import('views/dashboard')));
const Users = Loadable(lazy(() => import('views/users')));
const EditParams = Loadable(lazy(() => import('views/edit-params')));
const EditBarriere = Loadable(lazy(() => import('views/edit-barriers')));
const EditAttentionClasses = Loadable(lazy(() => import('views/edit-attention-classes/Index')));
const InterventionPlans = Loadable(lazy(() => import('views/intervention-plans')));
const Lotti = Loadable(lazy(() => import('views/intervention-plans/lotti')));
const AddBarriere = Loadable(lazy(() => import('views/intervention-plans/lotti/add-barriers')));
const PriceLists = Loadable(lazy(() => import('views/prices')));
const AddPrice = Loadable(lazy(() => import('views/prices/add-price')));
const Map = Loadable(lazy(() => import('views/map')));

const ParamsHistory = Loadable(lazy(() => import('views/params-history')));
const LogsPage = Loadable(lazy(() => import('views/logs')));
// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <SimulationPanel>
                <MainLayout />
            </SimulationPanel>
        </AuthGuard>
    ),
    children: [
        {
            path: '/net',
            element: <Map />
        },
        {
            path: '/analysis',
            element: <Dashboard />
        },

        // Configuration Routes
        {
            path: '/configuration/users',
            element: <Users />
        },
        {
            path: '/configuration/edit-params',
            element: <EditParams />
        },
        {
            path: '/configuration/edit-attention-classes',
            element: <EditAttentionClasses />
        },

        // Piani di intervento routes
        {
            path: '/intervention-plans',
            element: <InterventionPlans />
        },
        {
            path: '/intervention-plans/intervention-plan',
            element: <Lotti />
        },
        {
            path: '/intervention-plans/intervention-plan/lotti/lotto/add-barriers',
            element: <AddBarriere />
        },

        {
            path: '/edit-barriers',
            element: <EditBarriere />
        },

        {
            path: '/price-lists',
            element: <PriceLists />
        },
        {
            path: '/price-lists/add-price',
            element: <AddPrice />
        },

        //  History Routes
        {
            path: '/params-history',
            element: <ParamsHistory />
        },

        //  Logs Routes
        {
            path: '/logs',
            element: <LogsPage />
        }
    ]
};

export default MainRoutes;
